module.exports = __webpack_public_path__ + "img/promotion_3.4b0b8755.png";